var map = {
	"./logo": 306,
	"./logo.png": 306,
	"./logotipo": 226,
	"./logotipo.jpg": 556,
	"./logotipo.png": 226,
	"./logotipo.svg": 557,
	"./logotipo2": 307,
	"./logotipo2.png": 307,
	"./logotipo_mini": 308,
	"./logotipo_mini.svg": 308,
	"./people-default": 309,
	"./people-default.png": 309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 555;